import { MdOutlineAdminPanelSettings } from "react-icons/md";
import { VscQuestion } from "react-icons/vsc";
import AccordionComponent from "../../../../../components/common/AccordionComponent/AccordionComponent";
import type { ProviderSetupGuide } from "../../../constants/providerSetupGuides.constants";
import { renderRichStep } from "../../../utils/richSteps";
import styles from "./StepsAccordion.module.scss";

export interface StepsAccordionProps {
  /** Plain strings; `**…**` marks the UI labels the design bolds. */
  steps: string[];
  /** A caution above the steps — Outlook warns that IT often blocks external forwarding. */
  notice?: string | null;
  /** Empty or null hides the walkthrough entirely, so a provider can ship without one. */
  videoUrl?: string | null;
  phase: "forwarding" | "filter";
  providerName: ProviderSetupGuide["displayName"];
  forwardingAddress?: string | null;
}

const StepsAccordion = ({ steps, notice, videoUrl, phase, providerName, forwardingAddress }: StepsAccordionProps): JSX.Element => (
  <AccordionComponent
    className={styles.accordion}
    title={
      <span className={styles.title}>
        <VscQuestion aria-hidden="true" />
        Not sure how? See the steps
      </span>
    }
  >
    <span className={styles.divider} />
    {notice ? (
      <p className={styles.notice}>
        <MdOutlineAdminPanelSettings aria-hidden="true" />
        <span>{renderRichStep(notice, forwardingAddress, styles.addressChip)}</span>
      </p>
    ) : null}
    <ol className={styles.steps}>
      {steps.map((step) => <li key={step}>{renderRichStep(step, forwardingAddress, styles.addressChip)}</li>)}
    </ol>
    {videoUrl ? (
      <div className={styles.video}>
        <iframe
          src={videoUrl}
          title={`${providerName} ${phase} steps`}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    ) : null}
  </AccordionComponent>
);

export default StepsAccordion;
